// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Implement campaign popup here */
/* Popup */

/* Ai power search campaign 04-2024 popup */
.popup-divider {
  border-top: 1px solid #e1e3e5;
  width: 100%;
}

.ai-search-campaign-popup .campaign-slides {
  padding: 20px;
  position: relative;
}

.ai-search-campaign-popup .campaign-slides img {
  max-width: 580px;
  max-height: 360px;
}

.ai-search-campaign-popup .campaign-slides img:hover {
  cursor: pointer;
}

.ai-search-campaign-title {
  font-size: 20px;
  font-weight: 600;
  display: flex;
  padding: 20px;
  justify-content: space-between;
  align-items: center;
}
.ai-search-campaign-title .ai-search-campaign-btn {
  padding: 2px;
  border-radius: 2px;
}

.ai-search-campaign-title .ai-search-campaign-btn:hover {
  background: #e9ecf0;
}


@media (max-height: 590px) {

  .ai-search-campaign-title {
    font-size: 16px;
    font-weight: 600;
  }
  .Polaris-Modal-Dialog__Modal:has(.ai-search-campaign-popup) {
    width: auto;
    max-width: 590px;
  }

  .ai-search-campaign-popup .campaign-slides {
    padding: 10px;
  }
  .ai-search-campaign-popup .campaign-slides img {
    width: 570px;
    height: 350px;
  }
  .ai-search-campaign-popup .campaign-slides .actions {
    max-width: 560px !important;
    bottom: 31px !important;
  }
  .ai-search-campaign-popup .footer {
    padding: 6px 13px !important;
  }
  .ai-search-campaign-popup .footer .highlight {
    background: #ffebd3;
    border-radius: 4px;
    font-weight: 500 !important;
    font-size: 12px !important;
  }

  .ai-search-campaign-popup .footer button {
    padding: 8px;
  }
  .ai-search-campaign-popup .footer .Polaris-Button__Content {
    font-size: 14px;
  }
}

.ai-search-campaign-popup .campaign-slides .actions {
  max-width: 580px;
  width: 100%;
  position: absolute;
  bottom: 41px;
  display: flex;
  justify-content: center;
}

.ai-search-campaign-popup .campaign-slides .dots {
  display: flex;
  align-items: center;
  gap: 6px;
}

.ai-search-campaign-popup .campaign-slides .dot-slider {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ffffff;
}

.ai-search-campaign-popup .campaign-slides .dot-slider:hover {
  cursor: pointer;
}

.ai-search-campaign-popup .campaign-slides .dot-slider--active {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #fa752a;
}

.ai-search-campaign-popup .footer {
  padding: 16px 23px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ai-search-campaign-popup .footer .Polaris-Button {
  background: linear-gradient(293.21deg, #9b75ff -29.89%, #fc5e54 98.4%);
}

.ai-search-campaign-popup .footer .Polaris-Button__Content {
  font-weight: 700;
}

.ai-search-campaign-popup .footer .highlight {
  background: #ffebd3;
  border-radius: 4px;
  font-weight: 700;
  color: #fa752a;
  padding: 4px;
}
/* start - PPR campaign */
.ppr-campaign-popup {
  position: relative;
  background: #0D111C;
  border-radius: 8px;
  text-align: center;
  padding-top: 30px;
  padding-bottom: 32px;
}

.ppr-campaign-popup .ppr-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
}

.Polaris-Modal-Dialog__Modal:has(.ppr-campaign-popup) {
  max-width: 816px;
}

.ppr-campaign-popup .image img {
  width: 100%;
  height: auto;
  max-width: 816px;
}
.ppr-campaign-popup .ppr-campaign-content {
  position: absolute;
}

.ppr-campaign-popup .ppr-campaign-content>div:first-child {
  font-weight: 600;
  font-size: 32px;
  line-height: 38px;
  color: #FFFFFF;

}
.ppr-campaign-popup .ppr-campaign-content>div:last-child {
  color: #FFFFFF;
  width: 65%;
  margin: 10px auto 0 auto;
}

.ppr-campaign-popup .actions {
  position: absolute;
  display: flex;
  justify-content: center;
  bottom: 32px;
  width: 100%;
  font-weight: 600;
  gap: 10px;
} 

.ppr-campaign-popup .actions .Polaris-Button:first-child {
  border: 1px solid #8C9196;
  box-shadow: 0px 1px 0px 0px #0000000D;
  background: unset;
  color: #FFFFFF;
}

.ppr-campaign-popup .actions .Polaris-Button:last-child {
  background: #FF5F6D;
  box-shadow: 0px 8px 20px 0px #00000026;
  color: #FFFFFF;
}
/* end - PPR campaign */`, "",{"version":3,"sources":["webpack://./src/styles/campaign-popup.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC,UAAU;;AAEV,2CAA2C;AAC3C;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;;EAEE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;AACA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;;AAEhB;AACA;EACE,cAAc;EACd,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,cAAc;AAChB;AACA,uBAAuB","sourcesContent":["/* Implement campaign popup here */\n/* Popup */\n\n/* Ai power search campaign 04-2024 popup */\n.popup-divider {\n  border-top: 1px solid #e1e3e5;\n  width: 100%;\n}\n\n.ai-search-campaign-popup .campaign-slides {\n  padding: 20px;\n  position: relative;\n}\n\n.ai-search-campaign-popup .campaign-slides img {\n  max-width: 580px;\n  max-height: 360px;\n}\n\n.ai-search-campaign-popup .campaign-slides img:hover {\n  cursor: pointer;\n}\n\n.ai-search-campaign-title {\n  font-size: 20px;\n  font-weight: 600;\n  display: flex;\n  padding: 20px;\n  justify-content: space-between;\n  align-items: center;\n}\n.ai-search-campaign-title .ai-search-campaign-btn {\n  padding: 2px;\n  border-radius: 2px;\n}\n\n.ai-search-campaign-title .ai-search-campaign-btn:hover {\n  background: #e9ecf0;\n}\n\n\n@media (max-height: 590px) {\n\n  .ai-search-campaign-title {\n    font-size: 16px;\n    font-weight: 600;\n  }\n  .Polaris-Modal-Dialog__Modal:has(.ai-search-campaign-popup) {\n    width: auto;\n    max-width: 590px;\n  }\n\n  .ai-search-campaign-popup .campaign-slides {\n    padding: 10px;\n  }\n  .ai-search-campaign-popup .campaign-slides img {\n    width: 570px;\n    height: 350px;\n  }\n  .ai-search-campaign-popup .campaign-slides .actions {\n    max-width: 560px !important;\n    bottom: 31px !important;\n  }\n  .ai-search-campaign-popup .footer {\n    padding: 6px 13px !important;\n  }\n  .ai-search-campaign-popup .footer .highlight {\n    background: #ffebd3;\n    border-radius: 4px;\n    font-weight: 500 !important;\n    font-size: 12px !important;\n  }\n\n  .ai-search-campaign-popup .footer button {\n    padding: 8px;\n  }\n  .ai-search-campaign-popup .footer .Polaris-Button__Content {\n    font-size: 14px;\n  }\n}\n\n.ai-search-campaign-popup .campaign-slides .actions {\n  max-width: 580px;\n  width: 100%;\n  position: absolute;\n  bottom: 41px;\n  display: flex;\n  justify-content: center;\n}\n\n.ai-search-campaign-popup .campaign-slides .dots {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.ai-search-campaign-popup .campaign-slides .dot-slider {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #ffffff;\n}\n\n.ai-search-campaign-popup .campaign-slides .dot-slider:hover {\n  cursor: pointer;\n}\n\n.ai-search-campaign-popup .campaign-slides .dot-slider--active {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #fa752a;\n}\n\n.ai-search-campaign-popup .footer {\n  padding: 16px 23px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.ai-search-campaign-popup .footer .Polaris-Button {\n  background: linear-gradient(293.21deg, #9b75ff -29.89%, #fc5e54 98.4%);\n}\n\n.ai-search-campaign-popup .footer .Polaris-Button__Content {\n  font-weight: 700;\n}\n\n.ai-search-campaign-popup .footer .highlight {\n  background: #ffebd3;\n  border-radius: 4px;\n  font-weight: 700;\n  color: #fa752a;\n  padding: 4px;\n}\n/* start - PPR campaign */\n.ppr-campaign-popup {\n  position: relative;\n  background: #0D111C;\n  border-radius: 8px;\n  text-align: center;\n  padding-top: 30px;\n  padding-bottom: 32px;\n}\n\n.ppr-campaign-popup .ppr-close-btn {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n}\n\n.Polaris-Modal-Dialog__Modal:has(.ppr-campaign-popup) {\n  max-width: 816px;\n}\n\n.ppr-campaign-popup .image img {\n  width: 100%;\n  height: auto;\n  max-width: 816px;\n}\n.ppr-campaign-popup .ppr-campaign-content {\n  position: absolute;\n}\n\n.ppr-campaign-popup .ppr-campaign-content>div:first-child {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 38px;\n  color: #FFFFFF;\n\n}\n.ppr-campaign-popup .ppr-campaign-content>div:last-child {\n  color: #FFFFFF;\n  width: 65%;\n  margin: 10px auto 0 auto;\n}\n\n.ppr-campaign-popup .actions {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  bottom: 32px;\n  width: 100%;\n  font-weight: 600;\n  gap: 10px;\n} \n\n.ppr-campaign-popup .actions .Polaris-Button:first-child {\n  border: 1px solid #8C9196;\n  box-shadow: 0px 1px 0px 0px #0000000D;\n  background: unset;\n  color: #FFFFFF;\n}\n\n.ppr-campaign-popup .actions .Polaris-Button:last-child {\n  background: #FF5F6D;\n  box-shadow: 0px 8px 20px 0px #00000026;\n  color: #FFFFFF;\n}\n/* end - PPR campaign */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
